import React, { useState } from 'react'
import { Col, Divider, Flex, Modal, Row, Table, Tag, Tooltip, Input, Typography, Checkbox, Alert, Button, Select, Image } from 'antd';
import { netsuite_url } from '../config';
import { deliveryStatuses, StockReturnReasons } from '../common/Constants';
import { CalendarOutlined, DeleteFilled, ExportOutlined, InfoCircleOutlined, InfoCircleTwoTone, NumberOutlined, TagOutlined } from '@ant-design/icons';
import DetailsGrid from '../common/DetailsGrid';
import ProductScanSelect from '../../pages/Scan/ProductScanSelect';
import { useLoadingDispatch, showLoading, hideLoading } from '../../context/loadingContext';
import AuthService from '../auth/AuthService';
import { useSelector } from 'react-redux';
import { showMessage } from '../Utils/message';
import ScanSelect from '../../pages/Scan/ScanSelect';
import dayjs from 'dayjs';
import { getProductImageUrl } from '../../utils';
import ProductInfoModal from '../Modals/ProductInfoModal';
const Auth = new AuthService()

const StockDiscrepancyTab = ({ routeReturnData, setRouteReturnData, selectedRoute, handleCloseDrawer }) => {
  const { locations, products } = useSelector((state) => state?.AppState?.userCreds);
  const layoutDispatch = useLoadingDispatch()
  const { Option } = Select;
  const { Text } = Typography;
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [modalVisible, setModalVisible] = React.useState(false);
  const [stockTransactions, setStockTransactions] = React.useState([])

  const [returnedStock, setReturnedStock] = useState({
    product_id: null,
    location_id: null,
    quantity: "",
    status: null,
    remaining_quantity_check: false,
    full_pallet_check: false,
    show_remain: false,
    show_full: false
  });
  const [currentProduct, setCurrentProduct] = useState(null)

  const [modalVisibleProduct, setModalVisibleProduct] = React.useState(false);
  const [selectedProductDetails, setSelectedProductDetails] = React.useState({
    totalStock: 0,
    code: '',
    name: '',
    productDetails: [],
    selectedRecord: null
  });
      
    const imageUrl = getProductImageUrl(currentProduct);

  const productSelectValueChange = (val, isScanned) => {
    console.log('productSelectValueChange', val, isScanned);

    if (isScanned) {
      const selectedProduct = products?.find((pro) => pro?.code == val || pro?.barcode == val);
      const matchedProduct = selectedItem?.item_internal_id == selectedProduct?.netsuite_id ? true : false;
      if (selectedProduct && matchedProduct) {
        setCurrentProduct(selectedProduct)
        setReturnedStock({ ...returnedStock, product_id: selectedProduct?.netsuite_id, quantity: '', });
      } else {
        setCurrentProduct(null)
        setReturnedStock({ ...returnedStock, product_id: null, quantity: '', });
        showMessage('error', 'Invalid product selected')
      }
      
    } else {
      const selectedProduct = products?.find((pro) => pro?.netsuite_id == val);
      const matchedProduct = selectedItem?.item_internal_id == selectedProduct?.netsuite_id ? true : false;
      if (selectedProduct && matchedProduct) {
        setCurrentProduct(selectedProduct)
        setReturnedStock({ ...returnedStock, product_id: val, quantity: '', });
      } else {
        setCurrentProduct(null)
        setReturnedStock({ ...returnedStock, product_id: null, quantity: '', });
        showMessage('error', 'Invalid product selected')
      }
    }
  };

  const locationSelectValueChange = (val, isScanned) => {
    console.log('locationSelectValueChange', val, isScanned);
    if (!returnedStock?.product_id) {
      showMessage('error', 'Please select a product first')
      setReturnedStock({ ...returnedStock, location_id: null })
      return;
    }
    if (isScanned) {
      const matched = locations?.find(item => item.code === val);
      if (matched) {
        setReturnedStock({ ...returnedStock, location_id: matched.id });
      } else {
        showMessage('error', "No matching location");
      }
    } else {
      setReturnedStock({ ...returnedStock, location_id: val });
    }
  };

  const handleSelect = async (record) => {
    if (record?.batch_quantity < 1) return showMessage('error', 'No stock available for adjustments')
    showLoading(layoutDispatch)
    const dataToSend = {
      product_netsuite_id: record?.item_internal_id,
      route_status_id: selectedRoute?.id,
      purchase_order_details_batch_id: record?.purchase_order_details_batch_id,
      id: record?.batch_id,
    }
    try {
      const res = await Auth.fetch('/route/route-packing-returns-txn', {
        method: 'POST',
        body: JSON.stringify(dataToSend)
      })

      if (res?.ack) {
        console.log(res, 'respo');
        setStockTransactions(res?.returns_txns || [])
        setSelectedItem(record)
        const remaining = record?.remaining_batch_quantity;
        const selectedProduct = products?.find((pro) => pro?.netsuite_id == record?.item_internal_id);
        const fullPalletQty = selectedProduct?.cases_in_pallets;
        if (remaining > fullPalletQty) setReturnedStock({ ...returnedStock, show_full: true, show_remain: false })
        else setReturnedStock({ ...returnedStock, show_remain: true, show_full: false })
        setModalVisible(true)
      } else {
        setStockTransactions([])
        showMessage('error', res?.message)
      }

    } catch (err) {
      showMessage('error', 'something went wrong')
      // console.log(err);

    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const handleOkModal = async () => {
    if (!returnedStock?.location_id) return showMessage('error', 'Location is required');
    if (Number(returnedStock?.quantity) < 1) return showMessage('error', 'Quantity Must be greater than zero');
    const basePayload = {
      returned_quantity: returnedStock?.quantity,
      location_id: returnedStock?.location_id,
      product_id: returnedStock?.product_id,
      id: selectedItem?.batch_id,
      batch_code: selectedItem?.batch_code,
      supplier_batch_code: selectedItem?.supplier_batch_code,
      expiry_date: selectedItem?.expiry_date,
      returned_quantity_to_stock_status: returnedStock?.status,
      route_status_id: selectedRoute?.id
    }


    const submitStock = async (payload) => {
      showLoading(layoutDispatch);
      try {
        const res = await Auth.fetch('/route/route-packing-returns-txn', {
          method: 'PUT',
          body: JSON.stringify(payload),
        });

        if (res?.ack) {
          showMessage('success', res?.message);
          setModalVisible(false)
          setRouteReturnData((prev) =>
            prev.map((item) => {
              if (item.batch_id === selectedItem.batch_id) {
                const newRemaining = Math.max(
                  0,
                  (item.remaining_batch_quantity || 0) - Number(returnedStock.quantity)
                );
                return {
                  ...item,
                  remaining_batch_quantity: newRemaining,
                  returned_quantity:
                    (Number(item.returned_quantity) || 0) + Number(returnedStock.quantity),
                  returned_quantity_to_stock_status: returnedStock?.status
                };
              }
              return item;
            })
          );

          setReturnedStock({
            product_id: null,
            location_id: null,
            quantity: "",
            remaining_quantity_check: false,

          });
          hideLoading(layoutDispatch);


        } else {
          showMessage('error', res?.message);
          hideLoading(layoutDispatch);

          if (res?.capacity_increased_by) {
            const cases_in_pallets = products?.find(pro => pro?.netsuite_id == returnedStock?.product_id)?.cases_in_pallets || 0;
            const capcityCal = res?.capacity_increased_by * cases_in_pallets;
            const plusSignWithCapcity = capcityCal < 0 ? `${Math.abs(capcityCal)}` : capcityCal;
            if (plusSignWithCapcity >= cases_in_pallets) return showMessage('error', 'Please select another location, this location capacity is full');
            Modal.confirm({
              title: "Capacity Exceeded",
              content: (
                <div style={{ fontSize: 16 }}>
                  Location capacity exceeded by{" "}
                  <span style={{ color: "green", fontWeight: "bold", fontSize: 18 }}>
                    {Number(plusSignWithCapcity)?.toFixed(2)}
                  </span>{" "}
                  cases. Do you want to receive the stock anyway?
                </div>
              ),
              okText: "Yes",
              cancelText: 'Cancel',
              width: 600,
              okButtonProps: { size: "large" },
              cancelButtonProps: { size: "large" },
              onOk: () => submitStock({ ...payload, bypass_capacity_check: true })
            });
          }
        }
      } catch (err) {
        console.log(err);
        showMessage('error', 'Something went wrong');
        hideLoading(layoutDispatch);
      }
    };

    submitStock(basePayload);

  };

  const handleModalCancelProduct = () => {
    setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: '', name: '', productDetails: [], selectedRecord: null });
    setModalVisibleProduct(false);
  }

  const handleInfoClick = async (record) => {
    const product = products?.find((item) => item?.netsuite_id == record?.item_internal_id);
    showLoading(layoutDispatch)
    try {

      const res = await Auth.fetch(`/product/product-details?id=${record?.item_internal_id}`)
      if (res?.ack) {
        if (res?.product_details.length > 0) {
          const totalStock = res.product_details.reduce((sum, item) => sum + (Number(item.stock_level) || 0), 0);
          setSelectedProductDetails({ ...selectedProductDetails, totalStock: totalStock, code: product?.code, name: product?.name, productDetails: res?.product_details, selectedRecord: product });
          setModalVisibleProduct(true);
          hideLoading(layoutDispatch)

        } else {
          showMessage('error', 'No Details');
          hideLoading(layoutDispatch)
        }
      } else {
        setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: product?.code, name: product?.name, productDetails: [] });
        showMessage('error', res?.message)
        hideLoading(layoutDispatch)

      }

    } catch (error) {
      showMessage('error', 'something went wrong');
      hideLoading(layoutDispatch)
    }
  };

  const handleModalCancel = () => {
    setReturnedStock({
      product_id: null,
      location_id: null,
      quantity: "",
      remaining_quantity_check: false,
    });
    setModalVisible(false);
  };

  const handleDeleteItemTransaction = async (record) => {
    const payload = {
      id: record?.id,
    }
    showLoading(layoutDispatch)
    console.log(payload);
    try {
      const res = await Auth.fetch('/route/route-packing-returns-txn', {
        method: 'DELETE',
        body: JSON.stringify(payload)
      })
      if (res?.ack) {
        showMessage('success', res?.message)
        setModalVisible(false)

        setRouteReturnData((prev) =>
          prev.map((item) => {
            if (item.batch_id === selectedItem.batch_id) {
              const newRemaining = Math.max(
                0,
                (item.remaining_batch_quantity || 0) + Number(record.quantity)
              );

              return {
                ...item,
                remaining_batch_quantity: newRemaining,
                returned_quantity_to_stock_status: null,
                returned_quantity:
                  (Number(item.returned_quantity) || 0) - Number(record.quantity),
              };
            }
            return item;
          })
        );

        setReturnedStock({
          product_id: null,
          location_id: null,
          quantity: "",
          expiry_date: null,

        });
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      showMessage('error', 'something went wrong');
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const postData = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {
      route_status_id: selectedRoute?.id,
    }
    try {
      const res = await Auth.fetch(`/route/post-route-returns`, {
        method: "POST",
        body: JSON.stringify(dataToSend)
      });
      if (res?.ack) {
        showMessage('success', res?.message);
        handleCloseDrawer()
      } else {
        showMessage('error', res?.message);
      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
    }
    finally {
      hideLoading(layoutDispatch);
    }
  };


  const dataCol = [

    {
      title: "Shop Code",
      render: (text, record) => {
        return (
          <span>
            <a
              href={`${netsuite_url}/app/common/entity/custjob.nl?id=${record.customer_internal_id}`}
              target="_blank"
            >
              {record.customer_name}
            </a>
          </span>
        );
      },
    },
    {
      title: "Shop Name",
      dataIndex: "customer_project_id",
      key: "customer_project_id",
    },
    {
      title: 'Order',
      render: (text, record) => {
        return (
          <span>

            <a
              href={`${netsuite_url}/app/accounting/transactions/salesord.nl?id=${record?.internal_id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {record?.sale_order_no}
            </a>
          </span>
        );
      },
    },
    {
      title: 'Invoice',
      render: (text, record) => {
        return (
          <span>
            <a
              href={`${netsuite_url}/app/accounting/transactions/custinvc.nl?id=${record?.invoice_internal_id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {record?.invoice_no}
            </a>

          </span>
        );
      },
    },

    {
      title: "Item Code",
      render(record) {
        return (
          <Flex gap={5} align="center">
            <Tooltip title={'Product Info'}>
              <InfoCircleTwoTone
                style={{ fontSize: '22px', cursor: 'pointer', padding: '2px' }}
                onClick={() => handleInfoClick(record)}
              />
            </Tooltip>
            <span>{record?.item_id}</span>
          </Flex>
        )
      }
    },
    {
      title: "Item Name",
      dataIndex: "item_name",
      key: "item_name",
    },
    {
      title: "Ordered Qty",
      dataIndex: "quantity",
      key: "quantity",
      align: "center",
    },
    {
      title: "Packed Qty",
      render(record) {
        return <>{record?.packed_quantity || 0}</>
      },
      align: "center",
    },
    {
      title: "Delivered Qty",
      dataIndex: "delivered_quantity",
      key: "delivered_quantity",
      align: "center",
    },
    {
      title: "Returned Qty",
      align: "center",
      render(record) {
        return <>{record?.returnedQty || 0}</>
      },
    },

    {
      title: "Reason",
      render(record) {
        const status = deliveryStatuses.find(status => status.id === record?.delivery_status)
        return <>{record?.delivery_status ? status?.title : ''}</>
      },
    },
    {
      title: "Warehouse Received Qty",
      // dataIndex: "batch_quantity",
      // key: "batch_quantity",
      render(record) {
        return <>{record?.batch_quantity || 0}</>
      },
      align: "center",
    },
    {
      title: "Returned To Stock Qty",
      render(record) {
        return <>{record?.returned_quantity || 0}</>
      },
      align: "center",
    },
    {
      title: 'Remaining Qty',
      align: 'center',
      render(record) {
        return <Tag color={record?.remaining_batch_quantity > 0 ? 'red' : 'green'}>{record?.remaining_batch_quantity || 0}</Tag>
      },
    },
    {
      title: "Batch code",
      dataIndex: "batch_code",
      key: "batch_code",
      align: "center",
    },
    {
      title: "Supplier Batch code",
      dataIndex: "supplier_batch_code",
      key: "supplier_batch_code",
      align: "center",
    },
    {
      title: 'Stock Difference Status',
      render(record) {
        const status = StockReturnReasons.find((item) => item.id === record.returned_quantity_to_stock_status)
        return <>{status?.title ? status?.title : ''}</>
      },
    },
    // {
    //   title: "Warehouse Received QTY (Quarantine)",
    //   render: (text, record) => (

    //     <span
    //       style={{
    //         display: "flex",
    //         alignItems: "center",
    //         justifyContent: "center",
    //         background: record.returned_quantity != record.returnedQty ? '#ff0000' : '',
    //         fontSize: '16px',
    //         fontWeight: "bold"
    //       }}
    //     >{record.returned_quantity || 0}</span>

    //   ),
    // },
    {
      title: "Action",
      align: "center",
      render: (record) => (
        <Tooltip title="Select Item">
          <ExportOutlined
            className="animated-select-icon"
            onClick={() => {
              if (selectedRoute?.route_returned_by < 1) return showMessage('error', 'Route is not returned yet please update goods return')
              handleSelect(record)
            }}
          />
        </Tooltip>
      ),
    }
  ];

  const transactionCol = [


    // {
    //   title: 'Batch Code',
    //   dataIndex: 'batch_code',
    //   key: 'batch_code',
    // },
    // {
    //   title: 'Supplier Batch Code',
    //   dataIndex: 'supplier_batch_code',
    //   key: 'supplier_batch_code',
    // },
    {
      title: "Location",
      render(record) {
        const location = locations?.find((item) => item?.id === record?.location_id)
        return (
          <Flex gap={5} align="center">
            <span>{location?.code || ''}</span>
          </Flex>
        )
      }
    },


    {
      title: "Quantity",
      render(record) {
        return (
          <Flex gap={5} align="center">
            <span>{record?.quantity?.toLocaleString() || '0'}</span>
          </Flex>
        )
      }
    },
   
    {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{record?.expiry_date}</Tag>;
              }
            },



    {
      title: "Created At",
      render(record) {
        return (
          <Flex gap={5} align="center">
            <span>{record?.createdAt ? dayjs(record?.createdAt).format('DD-MM-YYYY HH:mm:ss') : null}</span>
          </Flex>
        )
      }
    },
    {
      title: "User",
      render(record) {
        if (!record) return "";

        const user = record?.user_name || "";
        const helper = record?.helper_name || "";

        if (helper) {
          return (
            <>
              {helper}{" "}
              {user && (
                <Tooltip title={`${user}`}>
                  <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
                </Tooltip>
              )}
            </>
          );
        }

        return <>{user}</>;
      }
    },

    // {
    //   title: "Action",
    //   align: "center",
    //   render: (record) => (
    //     <Tooltip title="Delete Transaction">
    //       <DeleteFilled style={{ color: 'red', fontSize: 22 }} onClick={() => handleDeleteItemTransaction(record)} />
    //     </Tooltip>
    //   ),
    // }
  ];

  if (selectedRoute?.route_returned_posted_by < 1) {
    transactionCol.push({
      title: "Action",
      align: "center",
      render: (record) => (
        <Tooltip title="Delete Transaction">
          <DeleteFilled style={{ color: 'red', fontSize: 22 }}
            // onClick={() => handleDeleteItemTransaction(record)}
            onClick={() => {
              Modal.confirm({
                title: 'Delete Transaction',
                centered: true,
                content: `Are you sure you want to delete this transaction?`,
                onOk: () => handleDeleteItemTransaction(record),
                okText: 'Delete',
                cancelText: 'Cancel',
                width: 600,
                okButtonProps: { size: "large" },
                cancelButtonProps: { size: "large" },
              });
            }}
          />
        </Tooltip>
      ),
    })
  }

  const infoItem = [
    { label: 'Total Quantity', value: selectedItem?.batch_quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} /> },
    { label: 'Remaining Quantity', value: selectedItem?.remaining_batch_quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} /> },
    {
      label: "Batch Code",
      value: selectedItem?.batch_code,
      icon: <TagOutlined style={{ color: "#1cfa1cff" }} />,
      type: 'text',

    },

    {
      label: "Supplier Batch Code",
      value: selectedItem?.supplier_batch_code,
      icon: <TagOutlined style={{ color: "#1cfa1cff" }} />,
      type: 'text',
    },
    {
      label: "Expiry Date",
      value: selectedItem?.expiry_date ? dayjs(selectedItem?.expiry_date).format('DD-MM-YYYY') : '',
      icon: <CalendarOutlined style={{ color: "#1cfa1cff" }} />,
      type: 'text',

    },
  ];
  return (
    <div>
      {
        !selectedRoute?.route_returned_posted_by > 0 && (
          <Flex justify='end' style={{ marginRight: 5 }}>
            <Button type='primary'
              onClick={() => {
                Modal.confirm({
                  title: 'Post Stock Discrepancies',
                  centered: true,
                  content: `Are you sure to post stock discrepancies for this route?`,
                  onOk: () => postData(),
                  okText: 'Post',
                  width: 600,
                  okButtonProps: { size: "large" },
                  cancelButtonProps: { size: "large" },
                });
              }}
            >
              Post Discrepancies
            </Button>
          </Flex>
        )
      }

      <Table
        style={{ marginTop: "10px" }}
        columns={dataCol}
        dataSource={routeReturnData}
        pagination={false}
        scroll={{ x: 'max-content' }}
        rowClassName={(record) => (record?.batch_quantity < 1 ? "highlight-row" : "")}

      />

      <Modal width={'70vw'} title={` Returned To Stock: ${selectedItem?.item_id} - ${selectedItem?.item_name}`}
        open={modalVisible}
        onOk={handleOkModal}
        onCancel={handleModalCancel}
        okText='Save'
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: !selectedRoute?.route_returned_posted_by > 0 && selectedItem?.remaining_batch_quantity > 0 && stockTransactions.length != 1 && 'none' } }}
      >
        <Divider style={{ margin: '10px 0' }} />
        <>
          <DetailsGrid infoItems={infoItem} />
          {
            (
              stockTransactions?.length < 1 &&
              selectedItem?.remaining_batch_quantity > 0 &&
              selectedRoute?.route_returned_posted_by < 1) && (
              <>
              <Row style={{ marginBottom: "10px" }}>
                <Col 
                  xs={{ span: 24, order: 2 }}
                  md={{ span: 14, order: 1 }}
                >
                <Row>
                  <Col style={{flex: 1}}>
                    <Text>Product</Text>
                    <ProductScanSelect
                      onValueChange={productSelectValueChange}
                      value={returnedStock?.product_id}
                      options={products} placeholder="Product"
                      size="large"
                      length={'100%'}
                    />
                  </Col>
                </Row>
                {
                  returnedStock?.product_id && (
                    <Row style={{ marginBottom: "10px" }}>
                      <Col style={{flex: 1}}>
                        <Text>Location</Text>
                        <ScanSelect onValueChange={locationSelectValueChange} autoFocus value={returnedStock?.location_id} options={locations} placeholder="Location" size="large" length={'100%'} capacityCheck={true} />
                      </Col>
                    </Row>
                  )
                }
                {
                  returnedStock?.location_id && (
                    <>
                      <Row >
                        <Col style={{flex: 1}}>
                          <Text>Returned To Stock Quantity</Text>
                          <Flex align="center" gap="small" wrap>
                            <Input autoFocus size="large" type='number' value={returnedStock?.quantity}
                              onChange={(e) => {
                                const newQty = e.target.value
                                if (e.target.value.includes('.')) return;
                                if (newQty > selectedItem?.batch_quantity) return showMessage('error', 'Quantity can not be greater than total quantity')
                                if (newQty > selectedItem?.remaining_batch_quantity) return showMessage('error', 'Quantity can not be greater than remaining batch quantity')
                                if (newQty < 0) {
                                  showMessage('error', 'Quantity cannot be negative');
                                  return;
                                }
                                setReturnedStock({ ...returnedStock, quantity: newQty })
                              }
                              }
                              placeholder="Quantity" />

                            {
                              returnedStock?.show_remain && (
                                <Checkbox
                                  checked={returnedStock?.remaining_quantity_check}
                                  style={{ fontSize: '16px', width: '100%' }}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const qtyRemaing = selectedItem?.remaining_batch_quantity;
                                    if (isChecked) {
                                      if (!returnedStock?.product_id) return showMessage('error', 'Please select a product first');
                                      if (!returnedStock?.location_id) return showMessage('error', 'Please select a location first');
                                      setReturnedStock({ ...returnedStock, quantity: qtyRemaing, remaining_quantity_check: isChecked, status: 1 });

                                    } else {
                                      setReturnedStock({ ...returnedStock, quantity: '', remaining_quantity_check: false, status: null });
                                    }

                                  }}
                                >
                                  Remaining Quantity
                                </Checkbox>
                              )
                            }
                            {
                              returnedStock?.show_full && (
                                <Checkbox
                                  checked={returnedStock?.full_pallet_check}
                                  size="large"
                                  style={{ fontSize: "16px", width: '100%' }}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    if (isChecked) {
                                      if (!returnedStock?.product_id) return showMessage('error', 'Please select a product first');
                                      if (!returnedStock?.location_id) return showMessage('error', 'Please select a location first');
                                      const selectedProduct = products?.find((pro) => pro?.netsuite_id == returnedStock?.product_id);
                                      const fullPalletQty = selectedProduct?.cases_in_pallets;
                                      setReturnedStock({ ...returnedStock, quantity: fullPalletQty, full_pallet_check: e.target.checked })

                                      // const selectedProduct = products?.find((pro) => pro?.netsuite_id == returnedStock?.product_id);
                                      // const qtyRemaing = selectedItem?.remaining_batch_quantity;
                                      // const fullPalletQty = selectedProduct?.cases_in_pallets;
                                      // if (fullPalletQty > qtyRemaing) {
                                      //   showMessage('error', 'Remaining quantity is less than pallet quantity')
                                      //   return;
                                      // } else {
                                      //   setReturnedStock({ ...returnedStock, quantity: fullPalletQty, full_pallet_check: e.target.checked })
                                      // }
                                    } else {
                                      setReturnedStock({ ...returnedStock, quantity: '', full_pallet_check: false });
                                    }

                                  }
                                  }
                                >
                                  Full Pallet
                                </Checkbox>
                              )
                            }

                          </Flex>


                        </Col>
                      </Row>
                      <Row style={{ marginBottom: "10px" }}>
                        <Col style={{flex: 1}}>
                          <Text>{ Number(returnedStock?.quantity) === Number(selectedItem?.remaining_batch_quantity) ? 'Stock Status' : 'Stock Difference Status'}</Text>
                          <Select
                            style={{
                              width: "100%",
                            }}
                            showSearch
                            size='large'
                            allowClear
                            value={returnedStock?.status}
                            placeholder="Status"
                            filterOption={(input, option) =>
                              option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                            onChange={(value) => {
                              setReturnedStock({ ...returnedStock, status: value });
                            }}
                          >
                            {StockReturnReasons?.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item?.title}
                              </Option>
                            ))}
                          </Select>
                        </Col>
                      </Row>
                    </>
                  )
                }
                </Col>
                {returnedStock?.product_id && (
                  <Col 
                      xs={{ span: 24, order: 1 }}
                      md={{ span: 6, offset: 2, order: 2 }}
                      style={{ textAlign: "center", marginBottom: 16 }}
                  >
                    <Image 
                        src={imageUrl}
                        preview={false}
                        style={{
                            width: "100%",
                            maxWidth: 300,
                            height: "auto",
                            objectFit: "contain",
                        }}
                    />
                  </Col>
                )}
                </Row>
              </>
            )
          }
          {
            selectedRoute?.route_returned_posted_by > 0 && (
              <Alert style={{ marginTop: 5 }} type='info' message='Stock discrepancies locked' />
            )
          }

          <Divider />
        </>

        <Flex justify='end' gap={5}>
          {stockTransactions?.length < 1 && selectedRoute?.route_returned_posted_by < 1 && selectedItem?.remaining_batch_quantity > 0 && (
            <>
              <Button onClick={handleModalCancel}>Cancel</Button>
              <Button type='primary' onClick={handleOkModal}>Save</Button>
            </>
          )

          }

        </Flex>

        {
          stockTransactions?.length > 0 &&
          (
            <>
              <h3 style={{ margin: 0 }}>Transactions</h3>
              <Table
                columns={transactionCol}
                dataSource={stockTransactions}
                pagination={false}
                scroll={{ x: 'max-content' }}
                rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
              />
            </>
          )
        }
      </Modal>
      <ProductInfoModal
        visible={modalVisibleProduct}
        onCancel={handleModalCancelProduct}
        selectedItemDetails={selectedProductDetails}
        selectedItems={selectedProductDetails?.productDetails}
        selectedRecord={selectedProductDetails?.selectedRecord}
      />
    </div>
  )
}

export default StockDiscrepancyTab
